import React from "react";

// tone -> [tint, text, border]. Light, minimal, translucent.
const TONES = {
  green: ["--tint-green", "--on-green", "--tint-green-border"],
  amber: ["--tint-amber", "--on-amber", "--tint-amber-border"],
  red: ["--tint-red", "--on-red", "--tint-red-border"],
  blue: ["--tint-blue", "--on-blue", "--tint-blue-border"],
  violet: ["--tint-violet", "--on-blue", "--tint-violet-border"],
};

/** The one status/label pill used across the admin console. */
const StatusPill = ({ tone = "neutral", icon: Icon, children, mono, style }) => {
  const t = TONES[tone];
  const colours = t
    ? { background: `hsl(var(${t[0]}) / 0.55)`, color: `hsl(var(${t[1]}))`, border: `1px solid hsl(var(${t[2]}) / 0.7)` }
    : { background: "hsl(var(--muted) / 0.5)", color: "hsl(var(--muted-foreground))", border: "1px solid hsl(var(--border))" };
  return (
    <span
      className={mono ? "num" : undefined}
      style={{
        display: "inline-flex", alignItems: "center", gap: 4, height: 20, padding: "0 8px", borderRadius: 999,
        whiteSpace: "nowrap", width: "fit-content", fontSize: 11, fontWeight: 500, lineHeight: 1, ...colours, ...style,
      }}
    >
      {Icon && <Icon size={11} strokeWidth={2} />}
      {children}
    </span>
  );
};

export default StatusPill;
